export default __webpack_public_path__ + "static/media/edit.3e6ad542.svg";